package at.apa.statistictracker.data.model.userproperty

import at.apa.statistictracker.data.model.statisticevent.StatisticEvent

sealed class UserProperty {
    abstract fun applyToEvent(event: StatisticEvent)
}



